import { useDrag } from 'react-use-gesture';
import { useEffect } from 'react';
export default ({ onSwipeDown, onSwipeUp, global }) => {
    const bind = useDrag(({ last, direction: [, diry] }) => {
        if (last) {
            if (diry < 0) {
                // swipe up is when vertical velocity is inferior to minus threshold
                onSwipeUp === null || onSwipeUp === void 0 ? void 0 : onSwipeUp();
            }
            else {
                onSwipeDown === null || onSwipeDown === void 0 ? void 0 : onSwipeDown();
            }
        }
    }, { domTarget: global ? document : null });
    useEffect(() => {
        if (global) {
            bind();
        }
    }, [global, bind]);
    return bind;
};
